import { render, staticRenderFns } from "./SlidersEntity.vue?vue&type=template&id=67225379&"
import script from "./SlidersEntity.vue?vue&type=script&lang=js&"
export * from "./SlidersEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports